import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Progress from './Progress';

export default class EpisodeRow extends Component {
  static propTypes = {
    onClickEpisode: PropTypes.func,
    onClickDownload: PropTypes.func,
    id: PropTypes.string,
    title: PropTypes.string,
    isProgressStarted: PropTypes.bool,
    progressPercentage: PropTypes.number,
    canIDownload: PropTypes.bool,
    titleUri: PropTypes.string,
    seasonNumber: PropTypes.string,
    srcIconDownload: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.handleClickView = this.handleClickView.bind(this);
    this.handleClickDownload = this.handleClickDownload.bind(this);
  }

  handleClickView() {
    const { id, onClickEpisode, seasonNumber, titleUri } = this.props;
    onClickEpisode({
      episodeId: id,
      number: seasonNumber,
      title: titleUri,
    });
  }

  handleClickDownload() {
    const { id, onClickDownload, seasonNumber, titleUri } = this.props;
    onClickDownload({ episodeId: id, number: seasonNumber, title: titleUri });
  }

  render() {
    const {
      title,
      isProgressStarted,
      progressPercentage,
      canIDownload,
      srcIconDownload,
    } = this.props;
    return (
      <div className="row card-view-episode-row">
        <div className={canIDownload ? 'col-xs-10' : 'col-xs-12'}>
          <button className="row-title" onClick={this.handleClickView}>
            {title}
          </button>
          <Progress
            progressPercentage={progressPercentage}
            active={isProgressStarted}
            styleContainer={{
              marginTop: '9px',
            }}
          />
        </div>

        {canIDownload && (
          <div className="col-xs-2 text-center">
            <button
              className="btn btn-sm btn-default download"
              onClick={this.handleClickDownload}
            >
              <img src={srcIconDownload} alt="" className="icon-inline" />
            </button>
          </div>
        )}
      </div>
    );
  }
}
